import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { Router } from "@angular/router";
import { ToastService } from "../../shared/services/toast.service";
import { jwtPayload } from "../../shared/commons/token-payload";
import { AuthService } from "../services/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  private logoutInProgress = false;

  constructor(
    private _router: Router,
    private _authService: AuthService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const jwt = localStorage.getItem('tristateToken');

    if(jwt) {
      const payload = jwtPayload();
      request = request.clone({ setHeaders: { Authorization: `Bearer ${jwt}` } });
      if (payload && payload.exp && Date.now() >= payload.exp * 1000) {
        if (!this.logoutInProgress) {
          this.logoutInProgress = true;
          this.Logout();
          return new Observable<HttpEvent<any>>();
        }
      }
    }

    return next.handle(request);
  }

  Logout() {
    localStorage.removeItem('tristateToken');
    this._router.navigateByUrl('/auth/login');
    this._authService.EmitSessionExpiredEvent();
    this.logoutInProgress = false;
  }

}

